// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCGhdU6YSZ9VGvDwAzpgMUtaNO9J7hw9Y0",
  authDomain: "amebogpt.firebaseapp.com",
  projectId: "amebogpt",
  storageBucket: "amebogpt.firebasestorage.app",
  messagingSenderId: "781673332788",
  appId: "1:781673332788:web:d6462ed78e388cf7b6ca61",
  measurementId: "G-GSW2HHNY6F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Analytics (only in browser)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;

